if($('.module--contact__header__images').length) {
  // const images = document.querySelector('.module--contact__header__images');
  const image1 = document.querySelector('.module--contact__header__images__image--1');
  const image2 = document.querySelector('.module--contact__header__images__image--2');
  const image3 = document.querySelector('.module--contact__header__images__image--3');

  window.addEventListener('scroll', () => {
    let y = window.scrollY; // get the vertical scroll position
    if (y > 0) { // check if user scrolled more than 0 from top of the browser
      // images.style.transform = `translateY(${y * 0.07}%)`;
      image1.style.transform = `translateY(${y * 0.1}%)`;
      image2.style.transform = `translateY(-${y * 0.1}%)`;
      image3.style.transform = `translateY(${y * 0.1}%)`;
    }
  });
}

$('.socials__link, .share-banner__content__links a').bind('animationiteration', function(){
  $(this).removeClass('link--hover');
})

$('.socials__link, .share-banner__content__links a').hover(function(){
  $(this).addClass('link--hover');        
})

// check the first three sections and add an offset to each aos effect so that it is immediately visible on mobile when on top of page
if ($(window).width() < 992) {
  $('main.main section:lt(3)').each(function(){
    $(this).find('[data-aos]').attr('data-aos-offset', '-100');
  });
}
